export { default } from './overlay-merge-tags';
export type { MergeTagOption } from './types';
